/**
 * Словник: nl.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_nl.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Wachten op de andere deelnemer...",
  connectionLost: "Verbinding verbroken",
  peerLeft: "👋 De andere deelnemer heeft het gesprek verlaten",
  connectionError: "🚫 Verbindingsfout",
  connectionFailedTryAgain: "🚫 Kan geen verbinding maken met de server. Probeer het opnieuw.",
  reconnectionFailed: "🚫 Verbinding verbroken. Herstellen is na {attempts} pogingen mislukt.",
  connectionErrorWithDetails: "🚫 Verbindingsfout: {error}",
  speakerLoud: "Luid",
  speakerEar: "Hoorn",
  copyRoomId: "Kamer-ID kopiëren",
  share: "Delen",
  linkCopied: "🔗 Link gekopieerd!",
  idCopied: "🆔 ID gekopieerd!",
  startMeeting: "Vergadering starten",
  chooseAction: "Kies een actie",
  createNewRoom: "Nieuwe kamer",
  scheduleCall: "Gesprek plannen",
  calendarOpened: "📅 Agenda geopend",
  linkCopiedToClipboard: "🔗 Link naar klembord gekopieerd",
  enterRoomId: "Kamer-ID",
  roomIdValidationError: "Een kamer-ID mag alleen letters, cijfers en koppeltekens bevatten",
  joinRoom: "DEELNEMEN",
  termsAndPrivacyHelp: "Voorwaarden en privacy | Hulp",
  invite: "Uitnodigen",
  mySettings: "Mijn instellingen",
  peerSettings: "Instellingen gesprekspartner",
  blockRemoteControl: "Bediening op afstand blokkeren",
  iAgreeToTerms: "Ik ga akkoord met de servicevoorwaarden",
  termsOfUse: "Gebruiksvoorwaarden",
  privacyPolicy: "Privacybeleid",
  howToUse: "Zo werkt het",
  termsAcceptanceRequired: "U moet akkoord gaan met de voorwaarden om de service te gebruiken",
  ok: "OK",
  permissionsRequired: "Toestemmingen vereist",
  permissionsNeededMessage: "Deze app heeft de volgende toestemmingen nodig om goed te werken:",
  permissionsNote: "Let op: als u toestemmingen wijzigt in Instellingen, start iOS de app opnieuw op. Dat is normaal.",
  permissionsEnableMessage: "Schakel deze toestemmingen in via de instellingen van uw apparaat om door te gaan.",
  cancel: "Annuleren",
  openSettings: "Instellingen openen",
  websocketError: "WebSocket-fout",
  roomFull: "De kamer is vol",
  timeExpired: "Tijd verstreken",
  remaining: "over",
  mediaPermissionsRequired: "Voor videogesprekken is toegang tot camera en microfoon nodig. Geef toestemming in uw browser.",
  mediaPermissionsRequiredMobile: "Voor videogesprekken is toegang tot camera en microfoon nodig. Geef toestemming in de app-instellingen.",
  browserSettings: "Browserinstellingen",
  openAppSettings: "Instellingen openen",
  grantPermissions: "Toestemming geven",
  permissionsNotGranted: "Geen toestemming gegeven. Geef toestemming om door te gaan.",
  permissionRequestError: "Fout bij het aanvragen van toestemmingen: {error}",
  camera: "Camera",
  microphone: "Microfoon",
  cameraDescription: "Om video te verzenden",
  microphoneDescription: "Om audio te verzenden",
  continueWithoutPermissions: "Doorgaan zonder toestemmingen",
  mediaPermissionsRequiredFallback: "Voor videogesprekken zijn mediatoestemmingen nodig. Geef toestemming in de browserinstellingen.",
  mediaPermissionsRequiredMobileFallback: "Voor videogesprekken zijn mediatoestemmingen nodig. Geef toestemming in de app-instellingen.",
  browserSettingsFallback: "Browserinstellingen",
  openAppSettingsFallback: "Instellingen openen",
  permissionsPermanentlyDenied: "Toestemmingen permanent geweigerd. Schakel ze in via de app-instellingen.",
  continueText: "Doorgaan",
  mirror: "Spiegel",
  fitContain: "Passend",
  fitCover: "Vullen",
  switchCamera: "Wisselen",
  block: "Blokkeren",
  pip: "PiP",
  mic: "Micro",
  video: "Video",
  speaker: "Luidspreker",
  readyToConnect: "Klaar om te bellen?",
  startOneOnOne: "Videogesprek starten",
  createPrivateLink: "Link binnen een seconde klaar",
  welcomeExplainer: "Maak een link en stuur die naar wie u maar wilt. De link opent ook zonder de app.",
  joinHaveLink: "Hebt u een link?",
  joinFieldHint: "Plak een link of ID",
  roomInputInvalid: "Plak een gesprekslink of kamer-ID (letters, cijfers en koppeltekens)",
  guestTitle: "U bent uitgenodigd voor een videogesprek",
  guestBody: "De kamer is klaar. Uw gesprekspartner ziet u zodra u deelneemt.",
  guestJoin: "Deelnemen",
  guestFreeNote: "Deelnemen is altijd gratis",
  guestCreateOwn: "Mijn eigen kamer maken",
  guestInvalidTitle: "Deze link lijkt niet te kloppen",
  guestInvalidBody: "Vraag opnieuw om de link of maak uw eigen kamer.",
  inviteCardTitle: "Uw kamer is klaar",
  inviteCardBody: "Stuur de link naar degene met wie u wilt praten",
  inviteShareLink: "Link delen",
  inviteCopy: "Kopiëren",
  inviteBrowserHint: "Opent in elke browser. U hoeft de app niet te installeren.",
  inviteSentHint: "Verstuurd? Uw gesprekspartner verschijnt hier zodra de link wordt geopend.",
  inviteShareMessage: "Doe mee aan mijn videogesprek op One2One 👋\nOpen gewoon de link. Het werkt in je browser, je hoeft niets te installeren:\n{link}",
  copyLink: "Link kopiëren",
  consentBannerText: "Mogen we gebruiksstatistieken verzamelen? Daaruit zien we welke functies worden gebruikt. Gespreksinhoud wordt nooit meegestuurd.",
  consentAllow: "Toestaan",
  consentDeny: "Niet toestaan",
  privacySettingsLink: "Statistiekinstellingen",
} as const;
